import { httpsCallable } from "firebase/functions";
import { functions } from "@/lib/firebase";
import type { OrgUserRole } from "@/types/firestore";
import type { RequestTypeDef, PriorityDef } from "@/types/support";

export interface SupportBootstrap {
  org: { id: string; name: string };
  supportEnabled: boolean;
  role: OrgUserRole;
  uid: string;
  agreements: Array<{ id: string; name: string; status: string; canApprove: boolean; requestTypes: RequestTypeDef[]; priorities: PriorityDef[] }>;
}

export async function supportCall<T = unknown>(staff: boolean, op: string, input: Record<string, unknown> = {}): Promise<T> {
  const result = await httpsCallable<Record<string, unknown>, T>(functions, staff ? "supportStaff" : "supportClient")({ op, ...input });
  return result.data;
}

export function canDecideSupportApproval(role: OrgUserRole | null, impersonating: boolean): boolean {
  return !impersonating && (role === "ORG_OWNER" || role === "ORG_ADMIN");
}
